import styled from "styled-components";

export const CarrouselContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;

  height: 460px;
  align-items: end;
  justify-content: space-between;
  border-radius: 20px;

  @media (max-width: 768px) {
    height: 340px;
  }

  img {
    background-color: ${(props) => props.theme["purple-300"]};
    object-position: center;
    object-fit: cover;
    height: 100%;
    width: 50%;
    border-radius: inherit;
    position: absolute;
    right: 0;

    @media (max-width: 768px) {
      height: 80%;
    }
  }
`;

export const TextWrapper = styled.div`
  position: relative;
  width: 106%;
  min-width: 0;
  height: 80%;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.25rem 4.25rem;
  gap: 0.75rem;
  overflow: hidden;
  background: ${(props) => props.theme["blue-700"]};
  background: linear-gradient(
    90deg,
    ${(props) => props.theme["blue-700"]} 0%,
    ${(props) => props.theme["blue-500"]} 35%,
    ${(props) => props.theme["blue-300"]} 100%
  );
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;

  h2 {
    font-weight: 500;
    flex-shrink: 0;
    padding-right: 2rem;
    width: 100%;
    min-width: 0;
    height: fit-content;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
    margin: 0;
    color: ${(props) => props.theme.white};

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }

  h3 {
    font-weight: 500;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    padding-right: 2rem;
    width: 100%;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
    overflow: hidden;
    margin: 0;
    color: ${(props) => props.theme.white};

    @media (max-width: 768px) {
      font-size: 0.875rem;
    }
  }

  div {
    position: absolute;
    bottom: 20px;
    left: 20px;
    box-shadow: red;
    /* box-shadow: 0px 0px 73px -5px red; */
    width: fit-content;
    border-radius: 8px;
  }
`;
